import { render, staticRenderFns } from "./MyWish.vue?vue&type=template&id=6cf88680&scoped=true&"
import script from "./MyWish.vue?vue&type=script&lang=js&"
export * from "./MyWish.vue?vue&type=script&lang=js&"
import style0 from "./MyWish.vue?vue&type=style&index=0&id=6cf88680&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf88680",
  null
  
)

export default component.exports